module.exports = __webpack_public_path__ + "static/img/Permiso(14).47d97d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/Permiso(14).jpg
// module id = fs6t
// module chunks = 0